export const wysiwygTranslations = {
  en: () => import('@core/prosemirror-legacy/locales/src/en.json').then(t => ({ en: t.default })),
  de: () => import('@core/prosemirror-legacy/locales/src/de.json').then(t => ({ de: t.default })),
  fr: () => import('@core/prosemirror-legacy/locales/src/fr.json').then(t => ({ fr: t.default })),
  nl: () => import('@core/prosemirror-legacy/locales/src/nl.json').then(t => ({ nl: t.default })),
  sv: () => import('@core/prosemirror-legacy/locales/src/sv.json').then(t => ({ sv: t.default })),
  fi: () => import('@core/prosemirror-legacy/locales/src/fi.json').then(t => ({ fi: t.default })),
};
